import { useTranslation } from 'react-i18next';

import type { Discount, DiscountKind } from '@nucleus-commerce/api-client/admin';
import { Badge } from '@nucleus-commerce/ui/components/badge';
import { cn } from '@nucleus-commerce/ui/lib/utils';

import { scheduleState, type ScheduleState } from '../schemas/discount-rules';

const SUCCESS = 'bg-success/15 text-success border-transparent dark:bg-success/20';
const NEUTRAL = 'border-border text-muted-foreground';
const INFO = 'bg-primary/10 text-foreground border-transparent';
const DANGER = 'bg-destructive/10 text-destructive border-transparent';

const STATE_TONE: Record<ScheduleState, string> = {
  scheduled: INFO,
  active: SUCCESS,
  expired: NEUTRAL,
  disabled: DANGER,
};

export function DiscountKindBadge({ kind }: { kind: DiscountKind }) {
  const { t } = useTranslation('discounts');
  return (
    <Badge variant="outline" className={kind === 'code' ? INFO : NEUTRAL}>
      {t(`kind.${kind}`)}
    </Badge>
  );
}

export function DiscountStateBadge({
  discount,
  className,
}: {
  discount: Pick<Discount, 'status' | 'startsAt' | 'endsAt'>;
  className?: string;
}) {
  const { t } = useTranslation('discounts');
  const state = scheduleState(discount);
  return (
    <Badge variant="outline" className={cn(STATE_TONE[state], className)}>
      {t(`state.${state}`)}
    </Badge>
  );
}
